(function($) {
    $.fn.eventAlert = function() {
        var now = Date.now();

        this.each(function() {
            var $event = $(this),
                startTimestamp = $event.data('start-timestamp') * 1000,
                endTimestamp = $event.data('end-timestamp') * 1000;

            function isCurrent() {
                return startTimestamp <= now && endTimestamp >= now;
            }

            function inTheFuture() {
                return startTimestamp >= now;
            }

            function showAlert() {
                $event.addClass('event-alert-show');
            }

            function hideAlert() {
                $event.removeClass('event-alert-show');
            }

            function setTimerToShowAlert() {
                var delay = startTimestamp - now;
                setTimeout(showAlert, delay);
            }

            function setTimerToHideAlert() {
                var delay = endTimestamp - now;
                setTimeout(hideAlert, delay);
            }

            $event.find('.close-alert').click(function() {
                $event.hide();
            });

            if (isCurrent()) {
                showAlert();
                setTimerToHideAlert();
            } else if (inTheFuture()) {
                setTimerToShowAlert();
                setTimerToHideAlert();
            }
        });

        return this;
    };
}(jQuery));
